// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"e1e99692","358":"72af2df4","408":"d51737a6","642":"1abf4731","659":"7c310868","720":"607183da","908":"5782fe23"}[chunkId] + ".chunk.js";
};